module.exports = __webpack_public_path__ + "media/svg-new/questions-81c4725b.svg";